import React from 'react';
import logo from '../assets/logo.png';
import { Menu } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import { MENU } from '../constants/index';

const items = [
  {
    key: MENU.home,
    label: '首页'
  },
  {
    key: MENU.service,
    label: '产品服务'
  },
  {
    key: MENU.example,
    label: '客户案例'
  },
  {
    key: MENU.consult,
    label: '联系我们'
  }
];

const useStyles = makeStyles(() => ({
  logo: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '@media (max-width: 1260px)': {
      '& span': {
        fontSize: '14px !important',
      },
      '& img': {
        width: '36px !important',
      }
    },
    '& img': {
      width: 52
    },
    '& span': {
      color: '#4cabbb',
      fontSize: 24,
      marginLeft: 12
    }
  },
  menu: {
    height: '100%',
    background: '#fff',
    '@media (max-width: 1260px)': {
      '& li': {
        fontSize: '10px',
        minWidth: '56px !important',
        padding: '0px 8px !important',
      }
    },
    '& .ant-menu-item': {
      minWidth: 88,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& span': {
        color: '#1d1d1d',
      }
    },
    '& .ant-menu-item-selected': {
      background: '#2158a5 !important',
      '& span': {
        color: '#fff !important'
      }
    }
  }
}));

const HeaderContent: React.FC<{ menuKey: string, setMenu: React.Dispatch<React.SetStateAction<string>> }> = ({ menuKey, setMenu }) => {
  const classes = useStyles();
  const onSelect = ({ key }: { key: string }) => {
    setMenu(key);
  };

  return (
    <>
      <div className={classes.logo} onClick={() => setMenu(MENU.home)}>
        <img src={logo} alt='' />
        <span>晟晗知产</span>
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[menuKey]}
        defaultSelectedKeys={[menuKey]}
        items={items}
        className={classes.menu}
        onSelect={onSelect}
      />
    </>
  );
};

export default HeaderContent;